<template>
  <div class="card modal-card-border">
    <div class="card-content">
      <div class="columns">
        <div class="column is-12">
          <h1 class="is-5">
            <span class="subtitle">
              Code Panneau n°
            </span>
            <span class="title is-5">{{face.panCode}}</span>
          </h1>
          <p class="has-text-default is-size-14px is-7" v-if="face.facCode">
            Face : {{face.facCode}}
          </p>
        </div>
      </div>
      <div class="level mb-3">
        <div class="level-left is-size-14px has-text-weight-bold has-text-default">
          Historique des affectations
        </div>
        <div class="level-right">
          <b-button class="is-primary" @click="$parent.close()">
            Retour
          </b-button>
        </div>
      </div>
    <v-client-table :data="historiques"
                      :columns="columns"
                      :options="options"
                      class="infoWindowMapTable">
        <div slot="date" slot-scope="props">
          Du {{formatDate(props.row.dateDebut)}} au {{formatDate(props.row.dateFin)}}
        </div>
        <div slot="type" slot-scope="props">
          <p>{{props.row.type}}</p>
        </div>
        <div slot="affectation" slot-scope="props">
          <p>{{props.row.affectation}}</p>
        </div>
      </v-client-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { getAffectationProduitUnitaireAsync } from '@/api/affectation/index';
import formatIsoDate from '@/services/general/formatIsoDate';
import { TEXTS, RESULTS_PER_PAGE, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import { DATE_MIN } from '@/configuration/general';
import gestionErreur from '@/services/general/gestionErreur';

export default {
  name: 'historique-affectations',
  props: ['face'],
  data() {
    return {
      trad: {
        date: 'Date',
        type: 'Type',
        affectations: 'Affectations',
      },
      historiques: [],
    };
  },
  computed: {
    columns() {
      return ['date', 'type', 'affectation'];
    },
    options() {
      return {
        headings: {
          date: this.trad.date,
          type: this.trad.type,
          affectation: this.trad.affectations,
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
      };
    },
  },
  methods: {
    formatDate(date) {
      if (date === null || date === undefined) {
        return '';
      }
      return moment(date).format('L');
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open({ container: null });
    try {
      const query = [
        {
          id: this.face.facNum,
          dureeAffectation: {
            dateDebut: formatIsoDate(DATE_MIN),
            dateFin: formatIsoDate(moment()),
          },
        },
      ];
      let result = (await getAffectationProduitUnitaireAsync(
        query, false, true,
      )).data.result;
      result = Object.values(result).flat();
      if (result.length) {
        result.forEach(el => {
          let type = 'LC';
          if (el.typeReference === 'Reseau') type = 'Réseau';
          const affectation = {
            type: type,
            dateDebut: el.dureeAffectation.dateDebut,
            dateFin: el.dureeAffectation.dateFin,
            affectation: el.libelle,
          };
          this.historiques.push(affectation);
        });
        this.historiques.sort((a, b) => {
          if (a.dateFin < b.dateFin) return -1;
          else if (a.dateFin === b.dateFin) return 0;
          return 1;
        });
      }
      loadingComponent.close();
    } catch (e) {
      gestionErreur(e.message, e);
      loadingComponent.close();
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/recherche/cartographie/historique.vue